import React from "react";
import { size } from "lodash";
import { IllustrationProps } from ".";

export default ({
  colors: {
    content: { secondary },
    chart: { primary },
    scheme,
  },
  options: { showLine },
}: IllustrationProps) => {
  const currentLineColor = size(scheme) === 1 ? scheme[0] : primary;

  return (
    <svg width="100%" height="100%" viewBox="0 0 440 120">
      {showLine && (
        <>
          <path
            fillOpacity={0.04}
            fill={currentLineColor}
            d="M0 106.14l147.11-22.66L293.555 21 440 73.378V120H0"
          />
          <path
            fill="none"
            stroke={currentLineColor}
            strokeWidth={3}
            d="M0 106l146.667-22.623L293.333 21 440 73.292"
          />
        </>
      )}
      <path
        d="M11.28 83.172c5.273 0 9.34-1.284 12.201-3.853 2.862-2.568 4.292-6.137 4.292-10.708 0-3.945-1.26-7.06-3.779-9.345-2.52-2.286-5.937-3.428-10.254-3.428-1.426 0-2.632.078-3.618.234-.986.157-1.821.293-2.505.41l.967-10.605h16.201v-6.123H2.52L.879 60.672l3.076 1.816a40.544 40.544 0 013.545-.63c1.348-.185 2.48-.278 3.398-.278 6.524 0 9.786 2.559 9.786 7.676 0 2.676-.811 4.707-2.432 6.094-1.621 1.386-3.984 2.08-7.09 2.08-1.758 0-3.662-.244-5.713-.733C3.4 76.21 1.582 75.516 0 74.617v6.24c2.734 1.543 6.494 2.315 11.28 2.315zm31.288-.586V71.482l3.78-3.105 10.4 14.209h8.086L50.977 64.1l13.037-13.916h-7.94l-9.785 10.43-3.896 4.863h-.176l.351-6.24V37h-6.826v45.586h6.826z"
        fill={secondary}
      />
    </svg>
  );
};
